import { useParams } from 'react-router-dom'
import { RouteProps } from '../../routes/AppRouter'
import { Show as ShowRequest } from '../../features/application/Show'
import { Title } from 'components/common/Title'

export function Show(props: RouteProps) {
    const { id } = useParams<{ id: string }>()
    return (
        <>
            <Title color={"black"} title={props.title || ''} />
            <ShowRequest id={id || props.id || ''} />
        </>
    )
}
